/**
 * Shared theme constants for Amy Philp gallery
 * Single source of truth for colors, fonts, shadows, and animations
 */

export const colors = {
  // Primary palette
  primary: "#5B8A8F",
  primaryLight: "rgba(91, 138, 143, 0.06)",
  primaryMuted: "rgba(91, 138, 143, 0.3)",

  // Neutral palette
  text: "#3A3A3A",
  textMuted: "#7A7A7A",
  background: "#F5F3F0",
  surface: "#FFFFFF",
  border: "#E8E6E3",

  // Accent
  accent: "#B8795F",
} as const;

export const fonts = {
  serif: "Georgia, serif",
  sans: "Helvetica Neue, sans-serif",
} as const;

export const shadows = {
  // For images - makes them pop off the page
  image: "0 8px 30px rgba(0,0,0,0.12), 0 4px 12px rgba(0,0,0,0.08)",

  // For cards/surfaces
  card: "0 4px 12px rgba(0,0,0,0.08), 0 2px 4px rgba(0,0,0,0.04)",
  cardHover: "0 8px 20px rgba(0,0,0,0.12), 0 4px 8px rgba(0,0,0,0.06)",
} as const;

export const animations = {
  // Scroll-triggered animations
  fadeInUp: {
    initial: { opacity: 0, y: 80 },
    animate: { opacity: 1, y: 0 },
    transition: { duration: 0.7, ease: "easeOut" as const },
  },

  fadeIn: {
    initial: { opacity: 0 },
    animate: { opacity: 1 },
    transition: { duration: 0.5, ease: "easeOut" as const },
  },

  // For headers
  headerFadeIn: {
    initial: { opacity: 0, y: 30 },
    animate: { opacity: 1, y: 0 },
    transition: { duration: 0.6, delay: 0.2, ease: "easeOut" as const },
  },
} as const;

export const spacing = {
  // Vertical spacing between pieces
  pieceSeparation: "mb-32",

  // Container max widths
  containerMax: "max-w-5xl",
  contentMax: "max-w-2xl",
} as const;

export const layout = {
  // Image max heights by aspect ratio
  imageMaxHeight: {
    wide: "60vh",
    tall: "70vh",
    square: "70vh",
  },
} as const;

// Gradient for exhibit headers - radial fade that dissipates into background
export const gradients = {
  exhibitHeader: `radial-gradient(ellipse 80% 60% at 50% 50%, ${colors.primaryLight} 0%, ${colors.background} 100%)`,
} as const;
